import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { User } from '../../../interfaces/User/UserWMS'
import { YesNoBadge } from '../../../components/YesNoBadge'
import React from 'react'
import { UserAutoCompleter } from '../../UserAdmin/components/UserAutoCompleter'
import {
  createDisplayTransformer,
  createBackendTransformer
} from '../../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'email',
    label: 'Email',
    type: 'text'
  },
  {
    order: 2,
    key: 'name',
    label: 'Nombre',
    type: 'custom',
    Component: UserAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 5,
    key: 'active',
    label: 'Activo',
    type: 'precreated'
  }
]

export const defaultFilters = []

export const userTableHeaders: TableHeaderConfigWithType<User>[] = [
  {
    field: 'userAlias',
    title: 'Nombre',
    sortable: false
  },
  {
    field: 'userName',
    title: 'email',
    sortable: false
  },
  {
    field: 'position',
    title: 'Nombre Posición',
    sortable: false,
    formater: (value: unknown) =>
      (value as { positionName?: string })?.positionName ?? '-'
  },
  {
    field: 'active',
    title: 'Activo',
    sortable: false,
    formater: (value: unknown) =>
      React.createElement(YesNoBadge, { value: value as boolean })
  }
]
